import { compose, withHandlers, withStateHandlers } from "recompose";

import { graphql } from "@apollo/client/react/hoc";

import { withRouter } from "react-router-dom";

import { ASSIGN_ANIMALS_TO_GROUP } from "api/MyLivestock/Groups/mutations";
import { GET_ANIMAL_BY_ID, GET_PERFORMANCE_CHART_DATA } from "api/MyLivestock/Animal/queries";
import { GET_GROUP_BY_ID } from "api/MyLivestock/Groups/queries";
import { GET_ANIMAL_HISTORY_BY_ID } from "api/MyLivestock/Activity/queries";

import { getBUFromLocalStorage } from "helpers/storage";

import ConfirmMoveToGroupModal from "./ConfirmMoveToGroupModal";

const moveAnimalToGroup =
  ({ match, animals, setRequesting, setError, assignAnimals, onClose, isRefetchSingleAnimalInfo }) =>
  async (props, showNotification): Promise<void> => {
    setRequesting(true);
    setError(null);

    const animalsData = animals.map((item) => item.id);

    const businessUnitId = getBUFromLocalStorage();

    try {
      const {
        data: {
          moveAnimalsToGroup: { errors },
        },
      } = await assignAnimals({
        variables: {
          input: {
            group: props.group.length > 0 ? props.group : null,
            animals: animalsData,
            date: new Date(),
          },
        },
        refetchQueries: () => {
          if (match.params.groupId && !isRefetchSingleAnimalInfo) {
            return [
              {
                query: GET_GROUP_BY_ID,
                variables: {
                  group: match.params.groupId,
                  businessUnit: businessUnitId,
                },
              },
            ];
          }

          if (isRefetchSingleAnimalInfo) {
            return [
              {
                query: GET_ANIMAL_BY_ID,
                variables: {
                  id: animalsData[0],
                },
              },
              {
                query: GET_PERFORMANCE_CHART_DATA,
                variables: {
                  animal: animalsData[0],
                },
              },
              {
                query: GET_ANIMAL_HISTORY_BY_ID,
                variables: {
                  first: 5,
                  after: "",
                  animal: animalsData[0],
                  activityTemplateSlugs: [],
                  activityTypeSlugs: [],
                },
              },
            ];
          }

          return [];
        },
      });

      setRequesting(false);

      if (errors) {
        setError(errors[0].message);
        showNotification({
          variant: "error",
          message: "Error updating group.",
        });
      } else {
        showNotification({
          message: "Group successfully updated.",
        });
        onClose();
      }
    } catch (e) {
      showNotification({
        variant: "error",
        message: "Error updating group.",
      });
      setRequesting(false);
      setError("Error updating group.");
    }
  };

export default compose(
  withRouter,
  graphql(ASSIGN_ANIMALS_TO_GROUP, {
    name: "assignAnimals",
  }),
  withStateHandlers(
    {
      error: null,
      requesting: false,
    },
    {
      setError:
        () =>
        (error): Record<string, unknown> => ({
          error,
        }),
      setRequesting:
        () =>
        (requesting): Record<string, unknown> => ({
          requesting,
        }),
    },
  ),
  withHandlers({
    moveAnimalToGroup,
  }),
)(ConfirmMoveToGroupModal);
